import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home.vue'
import Userlogin from '@/components/userlogin.vue'
import Userset from '@/components/userset.vue'
import Forus from '@/components/forus.vue'
import Vipinfo from '@/components/vipinfo.vue'
import Demo from '@/components/demo.vue'
import Down from '@/components/down.vue'
import News from '@/components/news.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/userlogin',
      name: 'Userlogin',
      component: Userlogin
    },
    {
      path: '/userset',
      name: 'Userset',
      component: Userset
    },
    {
      path: '/forus',
      name: 'Forus',
      component: Forus
    },
    {
      path: '/vipinfo',
      name: 'Vipinfo',
      component: Vipinfo
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/down',
      name: 'Down',
      component: Down
    },
    {
      path: '/news',
      name: 'News',
      component: News
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js